export enum IpPrinterFlavor {
  SUNMI = "SUNMI",
  STAR = "STAR",
}
